const API_BASE = (process.env.REACT_APP_API_URL || "").replace(/\/$/, "");

export async function sendContactForm(formData, source) {
  const response = await fetch(`${API_BASE}/api/contact`, {
    method: "POST",
    headers: {
      "Content-Type": "application/json",
    },
    body: JSON.stringify({
      ...formData,
      source,
    }),
  });

  const data = await response.json().catch(() => ({}));

  if (!response.ok) {
    throw new Error(data.message || "Failed to send message.");
  }

  return data;
}
